import { apiClientWithToken } from './client';

export interface InvitationDetails {
  id: string;
  invitationName: string;
  tenantName: string;
  domains: string[];
}

/**
 * `GET /api/v2/Invitation/{invitationId}/{tenantId}/details`.
 *
 * The controller is decorated `[AllowAnonymous]` but the class-level
 * `[Authorize(JwtBearer)]` is currently not bypassed (legacy MVC routing
 * with `EnableEndpointRouting=false`), so we have to send a bearer token.
 * Once the backend is fixed we can drop the token requirement.
 */
export const getInvitationDetails = async (
  token: string,
  invitationId: string,
  tenantId: string,
): Promise<InvitationDetails> => {
  const response = await apiClientWithToken(token).get<InvitationDetails>(
    `/api/v2/Invitation/${invitationId}/${tenantId}/details`,
  );
  return response.data;
};
